import React, {Fragment, useState, useEffect} from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ClearIcon from '@material-ui/icons/Clear';
import { MainListItems, LogOut } from './../listItems';
import Copyright from './Copyright';
import Button from '@material-ui/core/Button';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Loader from 'react-loader-spinner';

import CompanyList from './CompanyList';
import TooltipDismissable from './TooltipDismissable';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import pink from '@material-ui/core/colors/pink';

import history from '../../history';
import axios from 'axios';
import apiUrl from '../../constants.js';

const theme = createMuiTheme({
  palette: {
    primary: blue,
    secondary: pink,
  },
  status: {
    danger: 'orange',
  },
});

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  titleMargin: {
    flexGrow: 1,
    margin: '10px'
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 240,
  },
  btnRight: {
    float: 'right',
    margin: '10px'
  },
  spinnerDiv: {
    height: '400px',
    width: '100%',
    textAlign: 'center',
  },
  spinner: {
    marginTop: '150px',
    marginBottom: '150px'
  },
}));

export default function Company() {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [openTag, setOpenTag] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [tagName, setTagName] = useState("");
  const [tags, setTags] = useState([]);
  const [tagId, setTagId] = useState("");

  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('user_id');

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {

    let city_prefix = process.env.REACT_APP_CITY_PREFIX;
    let url = apiUrl+"v1/get-companies?id_user="+userId;

    if(typeof city_prefix !== "undefined"){
      url = url + "&city_prefix="+city_prefix;
    }

    axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': token,
        }
      }
    )
    .then(function (response) {
      setCompanies(response.data.companies);
      setTags(response.data.tags);
      setLoading(false);
    })
    .catch(function (error) {
      console.log(error);
      setLoading(false);
      logOut();
    });
  };


  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const logOut = () => {
    localStorage.removeItem('user_id');
    localStorage.removeItem('token');
    history.push(process.env.REACT_APP_PREFIX_DIR+'/login');
  };

  const handleRedirection = (route) => {
    history.push(process.env.REACT_APP_PREFIX_DIR+route);
  };

  const handleModalTag = (action) => {
    setOpenTag(action);
  };

  const handleSubmitDialogTag = (e) => {
    e.preventDefault();

    if(tagName.trim()!==""){
      setLoading(true);

      let url = apiUrl+"v1/tags/store";
      let data = new FormData();

      data.append("id_user", userId);
      data.append("name", tagName);

      let city_prefix = process.env.REACT_APP_CITY_PREFIX;

      if(typeof city_prefix !== "undefined"){
        data.append("city_prefix", city_prefix);
      }

      axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': token,
          }
        }
      )
      .then(function (response) {
        console.log(response);
        setTagName("");
        setTags(response.data);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });

    } else {
      alert("El campo  nombre es obligatorio");
    }
  }

  const addTagToCompany = (companyId, setCompanyTags) => {
      setLoading(true);

      let url = apiUrl+"v1/tags/attachToCompany";
      let data = new FormData();

      data.append("id_user", userId);
      data.append("id_tag", tagId);
      data.append("id_company", companyId);

      let city_prefix = process.env.REACT_APP_CITY_PREFIX;

      if(typeof city_prefix !== "undefined"){
        data.append("city_prefix", city_prefix);
      }

      axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': token,
          }
        }
      )
      .then(function (response) {
        setCompanies(response.data);

        const companyTags = response.data.filter(company => company.id === companyId)[0].company_tags;
        setCompanyTags(companyTags);
        setTagId("");
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const removeTag = (tag) => {
    if(window.confirm("¿Está seguro de eliminar esta etiqueta?")){
      setLoading(true);
      let url = apiUrl+"v1/tags/delete/"+tag.id+"?id_user="+userId;

      axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': token,
          }
        }
      )
      .then(function (response) {
        setTags(response.data);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });

      console.log("siiii");
    }
  }

  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

  return (
    <Fragment>
      <div>
        <Dialog
          open={openTag}
          onClose={() => handleModalTag(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={true}
          maxWidth = {'md'}
        >
        <form onSubmit={(e) => handleSubmitDialogTag(e)}>
          <DialogTitle id="alert-dialog-title">{"Etiquetas de busqueda"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            { loading ?
              <Grid item xs={12} sm={12} className={classes.spinnerDiv}>
                <Loader
                  type="Oval"
                  color="#00BFFF"
                  height={50}
                  width={50}
                  className={classes.spinner}
                />
              </Grid>
              :
              <Fragment>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  label="Nombre"
                  name="tagName"
                  type="tagName"
                  onChange={(e) => setTagName(e.target.value)}
                  value={tagName}
                />

                <div className="div_tooltip">
                  <br/>
                  <h4>Etiquetas</h4>
                  <br/>
                  <div className="tooltip_elements">
                  {
                    tags.length > 0 ?
                      tags.map((tag, index) => (
                        <TooltipDismissable
                          key={index}
                          tag={tag}
                          remove={removeTag}
                        />
                      ))
                    :
                      'No existen etiquetas disponibles'
                  }
                  </div>
                </div>

              </Fragment>
            }
            </DialogContentText>
          </DialogContent>
          <DialogActions>

          { loading ?
              null
            :
              <Fragment>
                <Button onClick={() => handleModalTag(false)} color="primary">
                  Cerrar
                </Button>
                <Button type="submit" color="primary" autoFocus>
                  Agregar
                </Button>
              </Fragment>
          }
          </DialogActions>
          </form>
        </Dialog>
      </div>


      <MuiThemeProvider theme={theme}>
        <div className={classes.root}>
          <CssBaseline />
          <AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
            <Toolbar className={classes.toolbar}>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
              >
                <MenuIcon />
              </IconButton>
              <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                Restaurantes
              </Typography>
            </Toolbar>
          </AppBar>
          <Drawer
            variant="permanent"
            classes={{
              paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
            }}
            open={open}
          >
            <div className={classes.toolbarIcon}>
              <IconButton onClick={handleDrawerClose}>
                <ChevronLeftIcon />
              </IconButton>
            </div>
            <Divider />
            <List>
              <MainListItems/>
            </List>
            <Divider />
            <List>
              <LogOut
                logOut={logOut}
              />
            </List>
          </Drawer>
          <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth="lg" className={classes.container}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Paper className={classes.paper}>

                    <Grid container spacing={3}>
                      <Grid item xs={8}>
                        <Typography component="h4" variant="h4" color="inherit" noWrap className={classes.titleMargin}>
                          Lista de Restaurantes
                        </Typography>
                      </Grid>
                      <Grid item xs={4}>

                        <Button
                          type="submit"
                          variant="contained"
                          color="default"
                          className={classes.btnRight}
                          onClick={()=>handleModalTag(true)}
                        >
                          Etiquetas
                        </Button>

                        {/*<Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          className={classes.btnRight}
                          onClick={() => handleRedirection("/companies/register")}
                        >
                          Registrar
                        </Button>*/}
                      </Grid>
                    </Grid>
                    <Divider />
                    <CompanyList
                      companies={companies}
                      tags={tags}
                      loading={loading}
                      setLoading={setLoading}
                      addTagToCompany={addTagToCompany}
                      tagId={tagId}
                      setTagId={setTagId}
                    />
                  </Paper>
                </Grid>
              </Grid>
              <Box pt={4}>
                <Copyright />
              </Box>
            </Container>
          </main>
        </div>
      </MuiThemeProvider>

    </Fragment>
  );
}
